export const PAYMENT_SYMBOLS = {
  creditCard: 'BRL',
  pix: 'BRL',
  wise: 'CLP',
}
